





















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import InfosGroup from '@/components/Group/InfosGroup.vue'
import Prog from '@/components/Group/Prog.vue'
import Membres from '@/components/Group/Membres.vue'
import AperProfil from '@/components/Group/AperProfil.vue'
import Messagerie from '@/components/Group/Messagerie.vue'
import RapportProg from '@/components/Group/RapportProg.vue'
import { getBoUrl } from '@/api/http-constants'
import Groupe from '@/components/Groups/Groupe.vue'
import Album from '@/components/Group/Album.vue'
import { ApiService } from '@/api/api.service'
import { IMember } from '@/types/member'
import Prix from '@/components/Group/Prix.vue'
import Avancement from '@/components/Group/Avancement.vue'
import AperMembres from '@/components/Groups/AperMembres.vue'

@Component({
    components: {
        InfosGroup,
        Prog,
        Membres,
        AperProfil,
        Messagerie,
        RapportProg,
        Groupe,
        Album,
        Prix,
        Avancement,
        AperMembres,
    },
})
export default class Group extends Vue {
    apiService = new ApiService()
    boUrl = getBoUrl()
    group = null
    selectedMember: IMember = null
    disableAnimation: boolean = false
    threadID: number = null

    get members(): IMember[] {
        if (!this.group) {
            return []
        }

        const _members = this.group.users.filter(user => {
            return user.state === 'member'
        })

        const members: IMember[] = _members.map(x => {
            const member: IMember = {
                id: x.id,
                name: x.name,
                owner: this.group.group.owner.id === x.id,
                famillyMembers: x.famillyMembers,
                hobbies: x.hobbies,
                sharedSpaces: x.sharedSpaces,
                identikits: x.identikits,
                comment: x.comment,
            }
            return member
        })
        return members
    }

    async created() {
        const groupID = this.$route.params.id
        const groupResp = await this.apiService.getGroup(groupID)
        const group = groupResp.data
        this.group = group
        console.log(JSON.parse(JSON.stringify(group)))

        const threadID = group.group.threads[0].id
        this.threadID = threadID
    }

    onMemberClick(member: IMember) {
        /**
         * On désactive les animations le temps du changement de membre
         * selectionne.
         */
        this.disableAnimation = true
        this.selectedMember = member
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.disableAnimation = false
            })
        })

        const aperMembresModal = $(this.$refs.aperMembresModal) as any
        aperMembresModal.modal('show')
    }
}
